import { createSelector } from 'reselect';


export const selectContacts = ({ dealers }) => dealers?.list;

const getCity = ({ city }) => city;

export const contactsListForFooter = createSelector(
    [selectContacts, getCity],
    (contacts, city) => {
        const { name } = city?.currentCity;
        if (Array.isArray(contacts)) {
            return contacts
                .filter(elem => (elem.type === 'center' || elem.type === 'office'))
                .map(val => ({
                    text: `${name ?? ''} ${ val['address'] ?? ''}. ${ val['hours'] ?? ''}`,
                }));
        }
        return [];
    }
);
